export default [{
    url: '/api/navs',
    method: 'get',
    response: () => {
        return {aaa: 'aaa'}  
    }
}]